import React, { createContext, useContext, useState, ReactNode } from 'react';
import Notification, { NotificationType } from '../components/common/Notification';

interface NotificationContextType {
    showNotification: (type: NotificationType, message: string, duration?: number) => void;
}

const NotificationContext = createContext<NotificationContextType | undefined>(undefined);

interface Notification {
    id: number;
    type: NotificationType;
    message: string;
    duration?: number;
}

export const NotificationProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [notifications, setNotifications] = useState<Notification[]>([]);
    const [idCounter, setIdCounter] = useState(0);

    const showNotification = (type: NotificationType, message: string, duration = 3000) => {
        const id = idCounter;
        setIdCounter(prevCounter => prevCounter + 1);

        setNotifications(prevNotifications => [
            ...prevNotifications,
            { id, type, message, duration }
        ]);
    };

    const closeNotification = (id: number) => {
        setNotifications(prevNotifications =>
            prevNotifications.filter(notification => notification.id !== id)
        );
    };

    return (
        <NotificationContext.Provider value={{ showNotification }}>
            {children}
            {notifications.map(notification => (
                <Notification
                    key={notification.id}
                    type={notification.type}
                    message={notification.message}
                    duration={notification.duration}
                    onClose={() => closeNotification(notification.id)}
                />
            ))}
        </NotificationContext.Provider>
    );
};

export const useNotification = (): NotificationContextType => {
    const context = useContext(NotificationContext);

    if (context === undefined) {
        throw new Error('useNotification трябва да се използва в NotificationProvider');
    }

    return context;
};